import { Layout, Spin } from 'antd';
import cls from 'clsx';
import type { CSSProperties, ReactNode } from 'react';

import { LoginHeader } from './LoginHeader';

import s from '@/shared/ui/AuthForm.module.css';

interface AuthFrameProps {
  spinning?: boolean;
  // The logo bar on top; the status pages draw their own logo
  header?: boolean;
  withLogout?: boolean;
  // A red bar under the header, e.g. why the session ended
  banner?: ReactNode;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

// The frame of every page for signed-out users: a full-height column with
// the logo bar and a full-screen loader over the whole page
export const AuthFrame = ({
  spinning = false,
  header = true,
  withLogout,
  banner,
  className,
  style,
  children,
}: AuthFrameProps) => (
  <Layout>
    <Spin
      size="large"
      spinning={spinning}
      classNames={{ root: s.spin, container: s.spinContainer }}
    >
      <div className={cls(s.page, className)} style={style}>
        {header && <LoginHeader withLogout={withLogout} />}
        {banner && <div className={s.banner}>{banner}</div>}
        {children}
      </div>
    </Spin>
  </Layout>
);
